import React, { useState } from 'react';
import styles from './styles.module.css';
import { TextField, Grid, Box, Paper, Button } from '@mui/material';
import AuthService from 'services/AuthService';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

export default function ForgetPassword(props) {
  const [username, setUsername] = useState('');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const history = useHistory();

  const sendOtpBtnPressed = async (e) => {
    if (!phone) {
      setErrorMessage('Mobile number should not be empty.');
      setTimeout(() => setErrorMessage(null), 4000);
      return;
    }
    setLoadingIndicator(true);
    setErrorMessage(null);
    setSuccessMessage(null);
    try {
      await AuthService.resetPassword({
        action: 'send_otp',
        mobile: phone,
      });
      setOtpSent(true);
      setSuccessMessage('OTP sent successfully to your WhatsApp number!');
      setTimeout(() => setSuccessMessage(null), 5000);
    } catch (error) {
      setErrorMessage(error.message || 'Failed to send OTP!');
      setTimeout(() => setErrorMessage(null), 5000);
    } finally {
      setLoadingIndicator(false);
    }
  };

  const resetBtnPressed = async (e) => {
    if (!phone || !otp || !newPassword || !confirmPassword) {
      setErrorMessage('All fields are required.');
      setTimeout(() => setErrorMessage(null), 4000);
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage('New password and confirm password do not match.');
      setTimeout(() => setErrorMessage(null), 4000);
      return;
    }
    setLoadingIndicator(true);
    setErrorMessage(null);
    setSuccessMessage(null);
    try {
      await AuthService.resetPassword({
        action: 'verify_otp',
        mobile: phone,
        otp: otp,
        username: username,
        new_password: newPassword,
      });
      setSuccessMessage('Password reset successfully! Redirecting to login...');
      setTimeout(() => {
        history.push('/login');
      }, 2000);
    } catch (error) {
      setErrorMessage(error.message || 'Failed to reset password!');
      setTimeout(() => setErrorMessage(null), 5000);
    } finally {
      setLoadingIndicator(false);
    }
  };

  return (
    <Grid className={styles.mainDiv}>
      <Box container className={styles.outerBoxFrameWithoutAd}>
        <Grid style={{ boxShadow: 3 }} item xs={12} sm={12}>
          <Grid className={styles.formBoxFrame} style={{ height: 'auto', minHeight: '440px' }}>
            <h2 className={styles.titleText} style={{ textAlign: 'center', color: '#272C86', margin: '10px 0 20px 0' }}>
              Reset Password
            </h2>

            {!otpSent ? (
              <>
                <div className={styles.textMarg} style={{ marginBottom: '15px' }}>
                  <label className={styles.label} style={{ fontSize: '13px', textAlign: 'center' }}>
                    Enter your registered mobile number to receive an OTP on WhatsApp
                  </label>
                </div>
                <div className={styles.textMarg}>
                  <TextField
                    name="phone"
                    size="small"
                    label="Mobile Number"
                    type="phone"
                    color="secondary"
                    fullWidth
                    value={phone}
                    onChange={(event) => setPhone(event.target.value)}
                  />
                </div>
                <Grid className={styles.textCenter} style={{ marginTop: '30px' }}>
                  <Button
                    className={styles.loginButton}
                    style={{ backgroundColor: '#272C86', margin: '0 auto', width: '100%' }}
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={sendOtpBtnPressed}
                    disabled={loadingIndicator}
                  >
                    {loadingIndicator ? 'Sending OTP...' : 'Send OTP'}
                  </Button>
                </Grid>
              </>
            ) : (
              <>
                <div className={styles.textMarg} style={{ marginBottom: '10px' }}>
                  <label className={styles.label} style={{ fontSize: '12px', color: '#666', textAlign: 'center' }}>
                    Enter the OTP received on WhatsApp for mobile {phone}
                  </label>
                </div>
                <div className={styles.textMarg}>
                  <TextField
                    name="otp"
                    size="small"
                    label="WhatsApp OTP"
                    type="text"
                    color="secondary"
                    fullWidth
                    value={otp}
                    onChange={(event) => setOtp(event.target.value)}
                  />
                </div>
                <div className={styles.textMarg}>
                  <TextField
                    name="username"
                    size="small"
                    label="Username"
                    type="text"
                    color="secondary"
                    fullWidth
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                  />
                </div>
                <div className={styles.textMarg}>
                  <TextField
                    name="newPassword"
                    size="small"
                    label="New Password"
                    type="password"
                    color="secondary"
                    fullWidth
                    value={newPassword}
                    onChange={(event) => setNewPassword(event.target.value)}
                  />
                </div>
                <div className={styles.textMarg}>
                  <TextField
                    name="confirmPassword"
                    size="small"
                    label="Confirm Password"
                    type="password"
                    color="secondary"
                    fullWidth
                    value={confirmPassword}
                    onChange={(event) => setConfirmPassword(event.target.value)}
                  />
                </div>
                <Grid className={styles.textCenter} style={{ marginTop: '20px' }}>
                  <Button
                    className={styles.loginButton}
                    style={{ backgroundColor: '#272C86', margin: '0 auto 10px auto', width: '100%' }}
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={resetBtnPressed}
                    disabled={loadingIndicator}
                  >
                    {loadingIndicator ? 'Resetting...' : 'Verify & Reset Password'}
                  </Button>
                </Grid>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginTop: '10px' }}>
                  <span onClick={sendOtpBtnPressed} style={{ color: '#272C86', cursor: 'pointer', fontWeight: 500 }}>
                    Resend OTP
                  </span>
                  <span onClick={() => setOtpSent(false)} style={{ color: '#666', cursor: 'pointer', fontWeight: 500 }}>
                    Change Number
                  </span>
                </div>
              </>
            )}

            {errorMessage && (
              <Paper className={styles.errorMsg} style={{ marginTop: '15px' }}>
                <span>{errorMessage}</span>
              </Paper>
            )}
            {successMessage && (
              <Paper
                className={styles.successMsg}
                style={{
                  padding: '8px',
                  color: 'green',
                  backgroundColor: '#e8f5e9',
                  textAlign: 'center',
                  marginTop: '15px',
                  border: '1px solid green',
                }}
              >
                <span>{successMessage}</span>
              </Paper>
            )}

            <Grid className={styles.forgotPasswordWrapper} style={{ marginTop: '20px', textAlign: 'center' }}>
              <Link to="/login" className={styles.forgotPassword} style={{ color: '#272C86', fontWeight: 500 }}>
                Back to Login
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}
